import './SearchTab.scss'

import { TabType } from '@react/SearchResults/SearchTypes'
import { cls } from '@react/utils/classname'
import { ReactElement, useRef } from 'react'

import { SearchLoadMoreButton, SearchNoResults, SearchResult, SearchSuggestion, SearchTopResults } from '../index'
import { SearchPublisherResult } from '../SearchPublisherResult'

type SearchTabProps = {
  tab: TabType
  loadMoreLabel: string
  isActive: boolean
  noResultsLabel: string
  suggestionLabel: string
  topResultsLabel: string
  onLoadMore: (id: string) => void
}

export function SearchTab({
  tab,
  loadMoreLabel,
  isActive,
  noResultsLabel,
  suggestionLabel,
  topResultsLabel,
  onLoadMore,
}: SearchTabProps): ReactElement {
  if (!isActive) {
    return null
  }

  const { results, tabId, title, teasers, topResults, quickLinks, resultsTotal, suggestion, showLoadMore } = tab
  const allTab = title === 'All' && (topResults?.items?.length || quickLinks?.items?.length || teasers)
  const showSearchNoResults = resultsTotal === 0
  const showSearchSuggestion = showSearchNoResults && suggestion !== ''
  const tabRef = useRef(null)
  const handelLoadMore = () => {
    onLoadMore(tabId)
  }

  return (
    <div className="tab" role="tabpanel" id={tabId} data-testid="search-tab-component">
      <div className="saas-search-result-tab__results-wrapper" ref={tabRef} tabIndex={0}>
        <div
          className={cls({
            'saas-search-result-tab--all-tab': allTab,
            'saas-search-result-tab--lists': !allTab,
          })}
        >
          {showSearchNoResults ? (
            <>
              <SearchNoResults label={noResultsLabel} />
              {showSearchSuggestion && <SearchSuggestion suggestion={suggestion} hidden={false} label={suggestionLabel} />}
            </>
          ) : title === 'Publisher' ? (
            results.map((result, index) => <SearchPublisherResult key={`result_${index}`} result={result} label={topResultsLabel} />)
          ) : (
            results.map((result, index) => <SearchResult key={`result_${index}`} result={result} label={topResultsLabel} />)
          )}
          {showLoadMore && <SearchLoadMoreButton label={loadMoreLabel} hidden={false} onClick={handelLoadMore} />}
        </div>
        {allTab && <SearchTopResults teasers={teasers} topResults={topResults} quickLinks={quickLinks} />}
      </div>
    </div>
  )
}
